import React, { useEffect, useState } from "react";
import { Pagination } from "antd";
import { message } from "antd";
import ReactLoading from "react-loading";
import { NavLink as Link } from "react-router-dom";
import { Tabs, Input } from "antd";
import { CheckCircleTwoTone } from "@ant-design/icons";
import { Tooltip } from "antd";
import { formatDateDDMMYYYY } from "../../utils/commonFunctions";
import { Table } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import moment from "moment";


import { checkPermission } from "../../utils/checkPermission";


const TodayCandidateList = ({ candidateList, count, pagenNo,filter }) => {
  const [canViewDocuments, setCanViewDocuments] = useState(false);
  const [current, setCurrent] = useState(1);

  useEffect(() => {
    const role = localStorage.getItem("user.role");
    if (role) {
      checkPermission(role, "documents_module", "view_documents").then(setCanViewDocuments);
    }
  }, []);
  const [tableData, setTableData] = useState([]);
  const onChange = (page) => {
    setCurrent(page);
    pagenNo(page);
  };
  
  const filterData = Object.fromEntries(
    Object.entries(filter).filter(([_, value]) => value !== "")
  );
  
  const generateData = () => {
    let data = []
    for(let i = 0; i<candidateList?.length; i++){
      data.push({
        name: candidateList[i]?.name,
        email: candidateList[i]?.email,
        phone: candidateList[i]?.mobileNo,
        emp_id : candidateList[i]?.empId,
        b_type : candidateList[i]?.trf?.businessType,
        process_name : candidateList[i]?.trf?.processName,
        application : candidateList[i]?.form?.name,
        location : candidateList[i]?.trf?.location,
        status: (candidateList[i]?.documentsVerifiedStatus ? (
          candidateList[i].IsSelected ? (
            <div className="d-flex approved">
              <div className="accept_icon">
                <i class="fa fa-check"></i>
              </div>
              Onboarded
            </div>
          ) : (
            <div className="d-flex review">
              <div className="review_icon">
                <i class="fa fa-clock-o"></i>
              </div>
              Ready For Onboarding
            </div>
          )
        ) : (
          <div className="d-flex pending">
            <div className="pending_icon">
              <i class="fa fa-clock-o"></i>
            </div>
            Pending
          </div>
        )),
        onboard_date :!candidateList[i]?.DateOfJoining
          ? ""
          : formatDateDDMMYYYY(new Date(candidateList[i]?.DateOfJoining)),
        action:(
          <>   
            {canViewDocuments && (
              <Link
              to={{
                pathname: `/documents/verify/candidate/${candidateList[i]?._id}?filter=${Object.keys(filterData)}&value=${Object.values(filterData)}`,
                state: {
                  candidateId: candidateList[i]?._id
                }
              }}>
              <button
                class="btn btn-sm btn-primary btn-table-control mx-1">
                View
              </button>
              </Link>
            )}
          </>
        )
      })
    }
    setTableData([...data]);
  };

  useEffect(() => {
    generateData();
  }, [candidateList, canViewDocuments]);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a?.name?.localeCompare(b?.name),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
        return (
          <>
            <Input
              autoFocus
              placeholder="Type text here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm();
              }}></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.name.toLowerCase().includes(value.toLowerCase());
      }
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: (a, b) => a?.email?.localeCompare(b?.email),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
        return (
          <>
            <Input
              autoFocus
              placeholder="Type text here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm();
              }}></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.email.toLowerCase().includes(value.toLowerCase());
      }
    },
    {
      title: "Phone No",
      dataIndex: "phone",
      key: "phone",
      sorter: (a, b) => a?.phone?.localeCompare(b?.phone),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
        return (
          <>
            <Input
              autoFocus
              placeholder="Type text here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm();
              }}></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.phone.toLowerCase().includes(value.toLowerCase());
      }
    },
    {
      title: "Onboarded Date",
      dataIndex: "onboard_date",
      key: "onboard_date",
      sorter: (a, b) => moment(a.onboard_date, "DD/MM/YYYY").unix() -
      moment(b.onboard_date, "DD/MM/YYYY").unix(),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
        return (
          <>
            <Input
              autoFocus
              placeholder="Type text here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm();
              }}></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.onboard_date.toLowerCase().includes(value.toLowerCase());
      }
    },
    {
      title: "Emp Id",
      dataIndex: "emp_id",
      key: "emp_id",
      sorter: (a, b) => a?.emp_id?.localeCompare(b?.emp_id),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
        return (
          <>
            <Input
              autoFocus
              placeholder="Type text here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm();
              }}></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.emp_id.toLowerCase().includes(value.toLowerCase());
      }
    },
    {
      title: "Location",
      dataIndex: "location",
      key: "location",
      sorter: (a, b) => a?.location?.localeCompare(b?.location),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
        return (
          <>
            <Input
              autoFocus
              placeholder="Type text here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm();
              }}></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.location.toLowerCase().includes(value.toLowerCase());
      }
    },
    {
      title: "Application",
      dataIndex: "application",
      key: "application",
      sorter: (a, b) => a?.application?.localeCompare(b?.application),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
        return (
          <>
            <Input
              autoFocus
              placeholder="Type text here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm();
              }}></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.application.toLowerCase().includes(value.toLowerCase());
      }
    },
    {
      title: "Business Type",
      dataIndex: "b_type",
      key: "b_type",
      sorter: (a, b) => a?.b_type?.localeCompare(b?.b_type),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
        return (
          <>
            <Input
              autoFocus
              placeholder="Type text here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm();
              }}></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.b_type.toLowerCase().includes(value.toLowerCase());
      }
    },
    {
      title: "Process Name",
      dataIndex: "process_name",
      key: "process_name",
      sorter: (a, b) => a?.process_name?.localeCompare(b?.process_name),
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => {
        return (
          <>
            <Input
              autoFocus
              placeholder="Type text here"
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm();
              }}></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.process_name.toLowerCase().includes(value.toLowerCase());
      }
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      fixed:'right'
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      fixed: "right",
    }
  ];

  return (
    <div className="card-body row p-3 border mb-2 bg-white cursor-pointer">
      <div style={{width:'100%'}}>
        <Table
          columns={columns}
          dataSource={tableData}
          pagination={{
            total:count,
            pageSizeOptions: ["5", "10", "30", "60", "100", "1000"],
            showSizeChanger: false,
            onChange: onChange
          }}
          scroll={{ x: true }}
          style={{ whiteSpace: "pre" }}
          exportFileName="details"
          size="small"
        />
      </div>
    </div>
  );
};

export default TodayCandidateList;
